import React from "react"
import JobOffering from "../../types/jobOffering"

export interface BackendContextData {
    documents: string[]
    addDocument: (name: string, document: File) => Promise<void>
    deleteDocument: (name: string) => Promise<void>
    downloadDocument: (name: string) => Promise<null | Blob>
    jobOfferings: JobOffering[]
    addJobOffering: (offering: JobOffering) => Promise<void>
    editJobOffering: (offering: JobOffering, removedOffering: JobOffering) => Promise<void>
    deleteJobOffering: (id: string) => Promise<void>
    login: (email: string, password: string, onAuthStateChange: ((loggedIn: boolean) => void)) => Promise<void>
    signedIn: boolean
    getDatenschutz: () => Promise<null | Blob>
}

const BackendContext = React.createContext<BackendContextData>({
    documents: [],
    addDocument: () => new Promise(() => { }),
    deleteDocument: () => new Promise(() => { }),
    downloadDocument: () => new Promise(() => null),
    jobOfferings: [],
    addJobOffering: () => new Promise(() => { }),
    editJobOffering: () => new Promise(() => { }),
    deleteJobOffering: () => new Promise(() => { }),
    signedIn: false,
    getDatenschutz: () => new Promise(() => null)
})

export default BackendContext
